import React from "react";
import { BarChart3, Sparkles, Brain } from "lucide-react";

export type GuruMode = "estrategico" | "mistico" | "estatistico";

const MODES: { id: GuruMode; label: string; icon: React.ComponentType<{ className?: string }>; emoji: string }[] = [
  { id: "estrategico", label: "Estratégico", icon: BarChart3, emoji: "📊" },
  { id: "mistico", label: "Místico", icon: Sparkles, emoji: "🔮" },
  { id: "estatistico", label: "Estatístico", icon: Brain, emoji: "🧠" },
];

interface Props {
  mode: GuruMode;
  onChange: (m: GuruMode) => void;
}

const GuruModeSelector: React.FC<Props> = ({ mode, onChange }) => {
  return (
    <div className="flex items-center gap-1 p-1 bg-card/60 border border-border rounded-full">
      {MODES.map((m) => {
        const active = mode === m.id;
        return (
          <button
            key={m.id}
            onClick={() => onChange(m.id)}
            aria-label={`Modo ${m.label}`}
            className={`flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-semibold transition-colors ${
              active
                ? "bg-gradient-to-r from-amber-500 to-yellow-500 text-zinc-900 shadow"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <span>{m.emoji}</span>
            <span className="hidden sm:inline">{m.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default GuruModeSelector;
